import type { FaireProductEntity } from "../../entity_types/product";

export const p_81ozsbcrsg: FaireProductEntity = {
  token: "p_81ozsbcrsg",
  type: "product",
  name: "Sale - Gold Dipped Shell Pendant Necklace Beach Jewelry",
  brandName: "Elsie & Zoey",
  imageUrl:
    "https://cdn.faire.com/fastly/f94e572cad977e77af5a2e74647df8fb2545eb2c4ebb88750bf0024713a5964d.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/b01212544ed31d51e957ad173f8f3f66ca5dba931965839bef1d8fb9359b28c5.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
